export default {"src":"/_next/static/media/logoblue.336b0e38.svg","height":238,"width":886,"blurWidth":0,"blurHeight":0};